import { withStyles, Box, BodyText } from 'vopay';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Title } from 'UI';
import ElinxSettingsForm from './ElinxSettingsForm';
import styles from './ElinxSettingsPage.module.scss';

const cn = withStyles(styles);

const ElinxSettingsPage = () => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });

  return (
    <div className={cn('elinxSettingsPage')}>
      <Box flx="col">
        <Box flx="col" gapSize="8px">
          <Title>{t('ELinx.title', { defaultValue: 'eLinx Settings' })}</Title>

          <BodyText className={cn('description')}>
            {t('ELinx.description', {
              defaultValue:
                'Set defaults for eLinx requests. Control request expiry, decline options, notifications, reminders and delivery channel.',
            })}
          </BodyText>
        </Box>

        <ElinxSettingsForm onClose={() => history.goBack()} />
      </Box>
    </div>
  );
};

export default ElinxSettingsPage;
